import { WorkflowFactory } from 'workflow/shared/factories'
import { Task, TaskFilterResult } from '../types'

export const buildTaskFromFilterResult = (filterResult: TaskFilterResult) => {
  if (!filterResult.workflow) {
    return {
      uuid: filterResult.uuid,
      des: filterResult.des,
      status: filterResult.uuid_status
    }
  }

  const workflow = WorkflowFactory.buildWorkflowFromFilterResult(
    filterResult.workflow[0]
  )

  const taskmodelUuid = workflow.state.tasks.find(
    ({ uuid }) => uuid === filterResult.uuid
  )?.taskmodel_uuid

  const taskmodels = workflow.workflowmodel_instructions_from_version.taskmodels
  const taskmodel = taskmodels.find(({ uuid }) => uuid === taskmodelUuid)

  return {
    uuid: filterResult.uuid,
    des: taskmodel?.des,
    status: filterResult.uuid_status,
    taskmodel: taskmodel,
    workflow
  } as Task
}

const TaskFactory = { buildTaskFromFilterResult }

export default TaskFactory
